let mutationObserver = new MutationObserver((mutations) => {
	mutations.forEach((mutation)=>{
		if(mutation.addedNodes.length>0) {
			mutation.addedNodes.forEach((node)=>{
				if(typeof node.querySelector !=="undefined"){
					VLW.initMutation(node);
				}
			});
		}
		if(mutation.removedNodes) {
			mutation.removedNodes.forEach((node)=>{
				if(typeof node.querySelector !=="undefined") {
					VLW.clearMutation(node);
				}
			});
		}
	});
});
mutationObserver.observe(document.documentElement, {
	attributes           : false,
	characterData        : false,
	childList            : true,
	subtree              : true,
	attributeOldValue    : false,
	characterDataOldValue: false
});